import short from "short-uuid";
export var FieldTypes;
(function (FieldTypes) {
    FieldTypes["string"] = "string";
    FieldTypes["enum"] = "enum";
    FieldTypes["int"] = "int";
    FieldTypes["boolean"] = "boolean";
    FieldTypes["long"] = "long";
    FieldTypes["float"] = "float";
    FieldTypes["timestamp"] = "timestamp";
    FieldTypes["array"] = "array";
})(FieldTypes || (FieldTypes = {}));
export function differenceSets(a, b) {
    return new Set([...a].filter((x) => !b.has(x)));
}
export function unionSets(a, b) {
    return new Set([...a, ...b]);
}
export function intersectionSet(a, b) {
    return new Set([...a].filter((x) => b.has(x)));
}
export function isIn(a, b) {
    //if a is in b
    let isIn = true;
    for (const item of a) {
        if (!b.has(item)) {
            isIn = false;
            break;
        }
    }
    return isIn;
}
export function eqSet(a, b) {
    if (a.size !== b.size) {
        return false;
    }
    return isIn(a, b);
}
export function random(a) {
    //randome between 0 and a-1
    return Math.floor(Math.random() * a);
}
export function generateRandomId() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2, 8);
}
export function getCurrentTime() {
    return Date.now();
}
export function getCurrentTimeInSec() {
    return Date.now() / 1000;
}
export function mapToObject(map) {
    const objectFromMap = Object.create(null);
    for (const [key, value] of map.entries()) {
        if (value instanceof Map) {
            objectFromMap[key] = mapToObject(value);
        }
        else {
            objectFromMap[key] = value;
        }
    }
    return objectFromMap;
}
export function isNil(value) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return value === undefined || value === null || Number.isNaN(value);
}
export function isNilOrEmptyString(value) {
    return isNil(value) || value === "";
}
export function generateUUID() {
    return short.generate();
}
export function isInteger(number) {
    return !isNaN(parseInt(number));
}
